import { render } from "./icon-search.svg?vue&type=template&id=962db3b4?inline"
const script = {}
script.render = render

export default script